
    import '/opt/buildhome/repo/packages/x/components/sources/index.zh-CN.md?watch=parent';
    export const demoIndex = {
  ids: ["sources-demo-basic","sources-demo-icon","sources-demo-expand","sources-demo-inline","sources-demo-_semantic"],
  getter: () => import(/* webpackChunkName: "meta__components__zh-CN" */'/opt/buildhome/repo/packages/x/components/sources/index.zh-CN.md?type=demo')
};